export const validRowHeightValues = ['relaxed', 'regular', 'condensed'] as const;
export type rowHeightValues = (typeof validRowHeightValues)[number];

export const validCaptionSideValues = ['top', 'bottom'] as const;
export type captionSideValues = (typeof validCaptionSideValues)[number];

export const getTableRowHeight = (rowHeight: rowHeightValues): string => {
  switch (rowHeight) {
    case 'relaxed':
      return '1.5rem';
    case 'regular':
    default:
      return '1rem';
    case 'condensed':
      return '0.5rem';
  }
};
